export const SECTIONS_LIST_REQUEST = 'SECTIONS_LIST_REQUEST'
export const SECTIONS_LIST_SUCCESS = 'SECTIONS_LIST_SUCCESS'
export const SECTIONS_LIST_FAIL    = 'SECTIONS_LIST_FAIL'

export const SECTION_DETAIL_REQUEST = 'SECTION_DETAIL_REQUEST'
export const SECTION_DETAIL_SUCCESS = 'SECTION_DETAIL_SUCCESS'
export const SECTION_DETAIL_FAIL    = 'SECTION_DETAIL_FAIL'

export const QUIZ_FETCH_REQUEST = 'QUIZ_FETCH_REQUEST'
export const QUIZ_FETCH_SUCCESS = 'QUIZ_FETCH_SUCCESS'
export const QUIZ_FETCH_FAIL    = 'QUIZ_FETCH_FAIL'

export const QUIZ_SUBMIT_REQUEST = 'QUIZ_SUBMIT_REQUEST'
export const QUIZ_SUBMIT_SUCCESS = 'QUIZ_SUBMIT_SUCCESS'
export const QUIZ_SUBMIT_FAIL    = 'QUIZ_SUBMIT_FAIL'
export const QUIZ_SUBMIT_RESET   = 'QUIZ_SUBMIT_RESET'
